import { Controller } from 'stimulus'

// Sample label printing. Print triggers (the header "Print Labels" link and
// each row's print icon) open a small popup listing the label stocks; choosing
// one opens that trigger's PDF in a new tab. Closes on outside click, Escape,
// or re-clicking the same trigger. Without JS the triggers fall back to plain
// links that print the server-side default size.
export default class extends Controller {
  static targets = ['menu', 'option']

  connect() {
    this.boundOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener('click', this.boundOutsideClick, true)
  }

  disconnect() {
    document.removeEventListener('click', this.boundOutsideClick, true)
  }

  // Opens the size popup under the clicked print link and points the size
  // options at that link's URL.
  open(event) {
    event.preventDefault()

    const trigger = event.currentTarget
    if (!this.menuTarget.classList.contains('hidden') && trigger === this.currentTrigger) {
      this.close()
      return
    }
    this.currentTrigger = trigger

    this.optionTargets.forEach((option) => {
      const url = new URL(trigger.href, window.location.origin)
      url.searchParams.set('label_size', option.dataset.size)
      option.href = url.toString()
    })

    this.position(trigger)
    this.menuTarget.classList.remove('hidden')
  }

  // Size options are real links (target=_blank) — just close after the click.
  choose() {
    this.close()
  }

  close() {
    this.menuTarget.classList.add('hidden')
    this.currentTrigger = null
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') this.close()
  }

  handleOutsideClick(event) {
    if (this.menuTarget.classList.contains('hidden')) return
    if (this.menuTarget.contains(event.target)) return
    if (this.currentTrigger && this.currentTrigger.contains(event.target)) return
    this.close()
  }

  // Fixed positioning so the popup isn't clipped by the table's scroll
  // container; nudged left if the trigger sits near the viewport edge.
  position(trigger) {
    const rect = trigger.getBoundingClientRect()
    const width = this.menuTarget.offsetWidth || 176
    const left = Math.min(rect.left, window.innerWidth - width - 8)

    this.menuTarget.style.top = `${rect.bottom + 4}px`
    this.menuTarget.style.left = `${Math.max(left, 8)}px`
  }
}
